<template>
  <div class="Tourvideos">
    <div class="Tourvideoswrapper">
      <div class="TourCard" v-for="(video, index) in videos" :key="index">
        <video
          :src="video.src"
          width="100%"
          controls
          ref="videoRefs"
          @play="pauseOthers(index)"
        ></video>
        <h3>{{ $t(video.title) }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import video1 from "@/assets/Videos/yulduz.mp4";
import video2 from "@/assets/Videos/video9.mp4";
import video3 from "@/assets/Videos/video8.mp4";

export default {
  data() {
    return {
      videos: [
        { src: video1, title: "reason7" },
        { src: video2, title: "tour" },
        { src: video3, title: "shermatov" },
      ],
    };
  },
  methods: {
    pauseOthers(currentIndex) {
      // Barcha video elementlarni olish
      this.$refs.videoRefs.forEach((video, index) => {
        if (index !== currentIndex && !video.paused) {
          video.pause();
        }
      });
    },
  },
};
</script>

<style>
.Tourvideoswrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.TourCard {
  width: 30%;
  color: white;
  text-align: center;
}

.TourCard h3 {
  font-size: 23px;
  line-height: 26px;
  font-weight: 400;
}

    @media (max-width: 1100px) {
    .TourCard h3 {
        font-size: 18px;
    }
    }

    @media (max-width: 768px) {
    .TourCard {
        width: 300px;
        color: white;
        text-align: center;
    }
    .Tourvideoswrapper {
        padding: 50px 0;
        gap: 40px;
        justify-content: center;
    }
    .TourCard h3 {
        font-size: 22px;
    }
    
    }
    @media(max-width:360px){
        .TourCard{
            width: 90%;
        }
    }
</style>
